import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

export const routes = [{
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: '首页',
      parent: '/',
      code: "10001",
    }
  },
  {
    path: '/industry',
    name: 'industry',
    // redirect: '/industry/researchReport',
    component: () => import('../views/commonPages'),
    meta: {
      title: '产品智库',
      code: "10002"
    },
    children: [{
      path: 'researchReport',
      name: 'researchReport',
      component: () => import('../views/commonPages/pages.vue'),
      meta: {
        title: '产业研究报告',
        parent: '/industry',
        code: "100021"
      }
    }, {
      path: 'expertList',
      name: 'expertList',
      code: "100022",
      component: () => import('../views/pages/expertList.vue'),
      meta: {
        title: '专家智库名录',
        parent: '/industry',
        code: "100022"
      }
    }, {
      path: 'detail',
      name: 'industryDetail',
      component: () => import('../views/pages/detail.vue'),
      meta: {
        title: '详情',
        parent: '/industry',
        hidden: true
      }
    }, ]
  },
  {
    path: '/association',
    name: 'association ',
    // redirect: '/association/introduction',
    component: () => import('../views/commonPages'),
    meta: {
      title: '关于协会',
      code: "10003"
    },
    children: [{
        path: 'introduction',
        name: 'introduction',
        component: () => import('../views/pages/introduction.vue'),
        meta: {
          title: '协会简介',
          parent: '/association',
          code: "100031"
        }
      }, {
        path: 'organization',
        name: 'organization',
        component: () => import('../views/pages/organization.vue'),
        meta: {
          title: '组织架构',
          parent: '/association',
          code: "100032"
        }
      },
      {
        path: 'regulations',
        name: 'regulations',
        component: () => import('../views/pages/regulations.vue'),
        meta: {
          title: '规章制度',
          parent: '/association',
          code: "100033"
        }
      }
    ]
  }, {
    path: '/memberCenter',
    name: 'memberCenter',
    // redirect: '/memberCenter/vipMember',
    component: () => import('../views/commonPages'),
    meta: {
      title: '会员中心',
      code: "10004"
    },
    children: [{
        path: 'vipMember',
        name: 'vipMember',
        component: () => import('../views/pages/network.vue'),
        meta: {
          title: '会员网络',
          parent: '/memberCenter',
          code: "100041"
        }
      }, {
        path: 'benefits',
        name: 'benefits',
        component: () => import('../views/pages/benefits.vue'),
        meta: {
          title: '会员权益',
          parent: '/memberCenter',
          code: "100042"
        }
      },
      {
        path: 'vipDescribe',
        name: 'vipDescribe',
        component: () => import('../views/pages/vipStyle.vue'),
        meta: {
          title: '会员风采',
          parent: '/memberCenter',
          code: "100043"
        }
      },
      {
        path: 'detail',
        name: 'memberCenterDetail',
        component: () => import('../views/pages/detail.vue'),
        meta: {
          title: '详情',
          parent: '/memberCenter',
          hidden: true
        }
      }
    ]
  }, {
    path: '/platformService',
    name: 'platformService',
    component: () => import('../views/components/platform.vue'),
    meta: {
      title: '平台服务',
      parent: '/platformService',
      code: "10005"
    }
  },
  {
    path: '/information',
    name: 'information',
    // redirect: '/information/notice',
    component: () => import('../views/commonPages'),
    meta: {
      title: '资讯通道',
      hidden: true
    },
    children: [{
        path: 'notice',
        name: 'notice',
        component: () => import('../views/commonPages/pages.vue'),
        meta: {
          title: '通知公告',
          parent: '/information',
          code: "100011"
        }
      },
      {
        path: 'news',
        name: 'news',
        component: () => import('../views/commonPages/pages.vue'),
        meta: {
          title: '协会要闻',
          parent: '/information',
          code: "100012"
        }
      }, {
        path: 'memberCenter',
        name: 'memberCenter',
        component: () => import('../views/commonPages/pages.vue'),
        meta: {
          title: '会员动态',
          parent: '/information',
          code: "100013"
        }
      },
      {
        path: 'industry',
        name: 'industry',
        component: () => import('../views/commonPages/pages.vue'),
        meta: {
          title: '产业动态',
          parent: '/information',
          code: "100014"
        }
      },
      {
        path: 'detail',
        name: 'informationDetail',
        component: () => import('../views/pages/detail.vue'),
        meta: {
          title: '详情',
          parent: '/information',
          hidden: true
        }
      }
    ]
  },
  {
    path: '/joinUs',
    name: 'joinUs',
    component: () => import('../views/pages/joinUs.vue'),
    meta: {
      title: '加入我们',
      hidden: true
    },
  }
]

const router = new VueRouter({
  routes
})

export default router